import { UNIT_TYPES } from "../../../../config/constants";
import { SelectOption } from "../types/productRegisterView.types";

/**
 * Static-method dropdown-option mapping for the register form's Tailwind
 * `FormSelect`, single-responsibility (option shaping only) — same
 * convention as `IngredientRegisterOptions`
 * (src/screens/lcaIngredients/ingredientRegister/services/IngredientRegisterOptions.ts).
 * Reads the same `UNIT_TYPES` constant the legacy `ProductUnitForm.tsx`
 * passes straight to its Semantic UI `DropDown`, so the option list stays
 * identical; only the control changed.
 */
export class ProductRegisterOptions {
  static unitTypes(): SelectOption[] {
    return UNIT_TYPES.map((option: { value: string | number; text: string }) => ({
      value: String(option.value),
      text: option.text
    }));
  }
}
